
import Vue from 'vue';
import { Label } from '@/model';

export default Vue.extend({
  name: 'LabelChip',
  inheritAttrs: false,

  props: {
    label: { type: Object as () => Label, required: true },
  },

  computed: {
    color(): string {
      const { r, g, b } = this.label.color;
      return `rgba(${r}, ${g}, ${b}, 1)`;
    },
    isDark(): boolean {
      const { r, g, b } = this.label.color;
      return (r * 299 + g * 587 + b * 114) / 1000 <= 128;
    },
  },
});
